import { Anchor, Box, Paragraph, Tooltip } from '@zillow/constellation-10';

const FAIR_HOUSING_ACCESSIBILITY_URL = 'https://www.hud.gov/helping-americans/disabilities';

const DisabledAccessAmenityTooltip = () => (
  <Box css={{ display: 'inline-flex', alignItems: 'center', alignSelf: 'center', flexShrink: 0 }}>
    <Tooltip.Root placement="top">
      <Tooltip.Trigger aria-label="Learn more about Disabled access" />
      <Tooltip.Portal>
        <Tooltip.Content>
          <Paragraph css={{ fontWeight: 'normal' }}>
            Select this if your property adheres to the{' '}
            <Anchor href={FAIR_HOUSING_ACCESSIBILITY_URL} target="_blank" rel="noopener noreferrer">
              Fair Housing Act Accessibility Requirements
            </Anchor>
            , or other similar design standard. If you&apos;re not sure if your rental meets those requirements,
            it&apos;s best to leave &quot;Disabled access&quot; unchecked and describe any accessibility features in the
            listing description.
          </Paragraph>
          <Tooltip.Arrow />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  </Box>
);

export default DisabledAccessAmenityTooltip;
